module.exports = __webpack_public_path__ + "img/ctrl-t-stub--i.11067f26.svg";